var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionalSignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.43,
    height: 36.573,
    viewBox: "0 0 36.43 36.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "directional-sign",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11851",
    "data-name": "Path 11851",
    d: "M36.359,92H2.071A1.072,1.072,0,0,0,1,93.071v10.715a1.071,1.071,0,0,0,1.071,1.071H6.715V107H8.857v-2.143H29.573V107h2.143v-2.143h4.643a1.071,1.071,0,0,0,1.071-1.071V93.071A1.072,1.072,0,0,0,36.359,92Zm-14.108,9.643H5.822a1.071,1.071,0,1,1,0-2.143H22.251a1.071,1.071,0,1,1,0,2.143Zm0-4.286H7.965a1.071,1.071,0,1,1,0-2.143H22.251a1.071,1.071,0,1,1,0,2.143Zm11.429,3.214a1.071,1.071,0,0,1-2.143,0v-1.7l-2.457,2.457a1.071,1.071,0,1,1-1.515-1.515l2.457-2.457h-1.7a1.071,1.071,0,1,1,0-2.143h4.286a1.072,1.072,0,0,1,1.071,1.071Z",
    transform: "translate(0 -85.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11852",
    "data-name": "Path 11852",
    d: "M36.359,332H2.071A1.072,1.072,0,0,0,1,333.071v10.715a1.072,1.072,0,0,0,1.071,1.072H36.359a1.072,1.072,0,0,0,1.071-1.072V333.071A1.072,1.072,0,0,0,36.359,332Zm-20.179,3.214H30.466a1.071,1.071,0,1,1,0,2.143H16.179a1.071,1.071,0,1,1,0-2.143Zm-5.314,4.6a1.071,1.071,0,1,1-1.515,1.515l-2.457-2.457v1.7a1.071,1.071,0,0,1-2.143,0v-4.286a1.071,1.071,0,0,1,1.071-1.071h4.286a1.071,1.071,0,1,1,0,2.143h-1.7Zm21.743,1.829H16.179a1.071,1.071,0,1,1,0-2.143H32.609a1.071,1.071,0,1,1,0,2.143Z",
    transform: "translate(0 -308.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11853",
    "data-name": "Path 11853",
    d: "M2.071,2.143H6.715V4.429H8.857V2.143H29.573V4.429h2.143V2.143h4.643a1.071,1.071,0,1,0,0-2.143H2.071a1.071,1.071,0,1,0,0,2.143Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionalSignIcon);
export default __webpack_public_path__ + "static/media/directional_sign_icon.c76e4f2f2c370336ce83a35a16279a5e.svg";
export { ForwardRef as ReactComponent };